import styled from "@emotion/styled";
import { theme } from "@xometry/xometry_loft";

export const FlowContainer = styled.div`
  div {
    padding: ${theme.space[1]} 0;
  }
`;
